// 职业数据
export const CLASSES = {
  sword:   { name:'剑魂',   emoji:'⚔️', weapon:'光剑', weaponType:'blade', faction:'鬼剑士',
             desc:'精通光剑的剑术大师，速度与技巧的化身。',
             hpBonus:0, atkBonus:2, defBonus:0, spdBonus:3,
             passive:'连击之心：普通攻击有20%概率连击造成双倍伤害',
             skillName:'刃影残光', skillDesc:'召唤光剑残影，造成250%攻击伤害，必定命中',
             skillCost:20, skillMult:2.5,
             skills:['sword_3hit_slash','sword_draw_cut','sword_rising_counter','sword_ultimate','sword_awaken'] },
  berserk: { name:'狂战士', emoji:'😡', weapon:'巨剑', weaponType:'blade', faction:'鬼剑士',
             desc:'以血气为源，越战越勇。HP越低攻击越高。',
             hpBonus:20, atkBonus:3, defBonus:-1, spdBonus:0,
             passive:'血怒：HP低于50%时攻击力+40%',
             skillName:'血腥收割', skillDesc:'无视防御造成200%攻击伤害，有30%概率使敌人虚弱(-3防)',
             skillCost:18, skillMult:2.0,
             skills:['berserk_mountain','berserk_bloodrage','berserk_blood_burst','berserk_ultimate','berserk_awaken'] },
  ghost:   { name:'鬼泣',   emoji:'👻', weapon:'太刀', weaponType:'blade', faction:'鬼剑士',
             desc:'召唤鬼神之力作战的黑暗剑士。',
             hpBonus:-10, atkBonus:1, defBonus:0, spdBonus:1,
             passive:'鬼神附体：技能攻击有35%概率造成三倍伤害',
             skillName:'斩魂破·极', skillDesc:'鬼神之力爆发，造成220%伤害并有50%使敌人晕眩1回合',
             skillCost:22, skillMult:2.2,
             skills:['ghost_slash','ghost_ice_saya','ghost_tombstone','ghost_ultimate','ghost_awaken'] },
  asura:   { name:'阿修罗', emoji:'🌀', weapon:'短剑', weaponType:'blade', faction:'鬼剑士',
             desc:'以波动之力感知世界的盲剑客。',
             hpBonus:0, atkBonus:2, defBonus:1, spdBonus:0,
             passive:'波动感知：有25%概率完全回避敌人攻击',
             skillName:'波动升华', skillDesc:'释放波动之力，攻击所有弱点，造成200%伤害并回复15HP',
             skillCost:20, skillMult:2.0,
             skills:['asura_wave_burst','asura_killing_intent','asura_immobile_king','asura_ultimate','asura_awaken'] },
  ranger:  { name:'漫游者', emoji:'🎯', weapon:'双枪', weaponType:'gun', faction:'神枪手',
             desc:'双枪猎人，远程精准射击专家。',
             hpBonus:-5, atkBonus:4, defBonus:-2, spdBonus:4,
             passive:'鹰眼：普通攻击额外+3攻击力，命中必定暴击一次/战斗',
             skillName:'飞镖龙卷风', skillDesc:'投出无数飞镖，造成270%伤害，低HP敌人额外+50%',
             skillCost:22, skillMult:2.7,
             skills:['ranger_eagle','ranger_mobile_shot','ranger_headshot','ranger_ultimate','ranger_awaken'] },
  launcher:{ name:'枪炮师', emoji:'💣', weapon:'大炮', weaponType:'gun', faction:'神枪手',
             desc:'携带重型武器的炮台战士。',
             hpBonus:15, atkBonus:5, defBonus:2, spdBonus:-2,
             passive:'重装甲：受到伤害时，有25%概率减免50%伤害',
             skillName:'量子炮', skillDesc:'发射超级炮弹，无视防御造成300%伤害，有20%概率两连爆炸',
             skillCost:28, skillMult:3.0,
             skills:['launcher_laser','launcher_flame','launcher_quantum','launcher_ultimate','launcher_awaken'] },
  crusader:{ name:'圣骑士', emoji:'🛡️', weapon:'圣锤', weaponType:'holy', faction:'圣职者',
             desc:'圣光加持的近战圣战士，攻防兼备。',
             hpBonus:25, atkBonus:1, defBonus:3, spdBonus:0,
             passive:'圣盾庇护：每次受到攻击后恢复5HP',
             skillName:'圣光审判', skillDesc:'召唤圣光柱，造成180%伤害，同时为自己恢复25HP',
             skillCost:18, skillMult:1.8,
             skills:['crusader_holy_cross','crusader_blessing','crusader_holy_shield','crusader_ultimate','crusader_awaken'] },
  monk:    { name:'混沌',   emoji:'👊', weapon:'双拳', weaponType:'fist', faction:'圣职者',
             desc:'混沌之力与圣光交织的近身格斗家。',
             hpBonus:10, atkBonus:3, defBonus:0, spdBonus:2,
             passive:'混沌共鸣：技能攻击成功后下次普攻伤害+50%',
             skillName:'混沌破晓', skillDesc:'混沌与圣光同时爆发，造成240%伤害，自身攻击力永久+2',
             skillCost:24, skillMult:2.4,
             skills:['monk_demon_hand','monk_dark_cut','monk_hell_gate','monk_ultimate','monk_awaken'] },
};
